import { render, staticRenderFns } from "./TeamPartner.vue?vue&type=template&id=6a36a5d0&scoped=true&"
import script from "./TeamPartner.vue?vue&type=script&lang=js&"
export * from "./TeamPartner.vue?vue&type=script&lang=js&"
import style0 from "./TeamPartner.vue?vue&type=style&index=0&id=6a36a5d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a36a5d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSkeletonLoader})
